import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from "@angular/router";
import { RoomsService } from '../rooms/rooms.service';
import { Search } from '../model/search';
import { Empresa } from '../model/empresa';
import * as moment from 'moment';
import { MotorService } from '../services/motor.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {

  public empresa: Empresa;
  public selectedDate = new Date();
  public search: Search = Search.default();

  constructor(
    private readonly router: Router,
    private readonly motorService: MotorService,
    private readonly roomsService: RoomsService,
    private spinnerService: NgxSpinnerService

  ) {
    this.motorService.empresaObservable.subscribe(empresa => this.empresa = empresa);
  }

  ngOnInit() {    
  }

  async buttonPesquisarOnClick() {
    const quartosDisponiveis = await this.roomsService.listarQuartosDisponiveis(this.search);
    // Enviando o Array de Elementos como Parametro para a Proxima Rota...
    this.search.noites = this.quantidadeNoites();
    const dados = {
      quartos: quartosDisponiveis,
      search:  this.search
    };
    this.router.navigate(["company", this.empresa.token_motor, 'rooms'], {state: {
      spinner: this.spinner(), 
      dados:  dados
      }});
  }
  
  inlineRangeChange(event) {
    this.search.dataInicial = event.begin;
    this.search.dataFinal   = event.end;
    return this.quantidadeNoites();
  }

  //calcula a quantidade de noites
  quantidadeNoites() {
    let primeiraNoite = moment(this.search.dataInicial);
    let ultimaNoite   = moment(this.search.dataFinal);     
    return ultimaNoite.diff(primeiraNoite, 'days');
  }
  spinner(): void {
    this.spinnerService.show();
    setTimeout(() =>{
      this.spinnerService.hide();
    }, 2000);
  }
 
}
